import { render, staticRenderFns } from "./ILikeItButton.vue?vue&type=template&id=6969e8f9&scoped=true&"
import script from "./ILikeItButton.vue?vue&type=script&lang=js&"
export * from "./ILikeItButton.vue?vue&type=script&lang=js&"
import style0 from "./ILikeItButton.vue?vue&type=style&index=0&id=6969e8f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6969e8f9",
  null
  
)

export default component.exports